import Stack from '@mui/material/Stack';

import styled from 'shared/utils/styled';

type ContainerAccessories = Partial<{
  expanded: boolean;
}>;

export const Container = styled(Stack, {
  shouldForwardProp: (prop) => prop !== 'expanded',
})<ContainerAccessories>(({ expanded = false }) => ({
  position: 'relative',
  display: 'flex',
  padding: '20px 30px 10px 10px',
  background: 'transparent',
  transition: 'all .15s linear',
  ...(expanded && {
    background: 'rgba(34, 64, 96, 0.06)',
  }),
}));

export const Text = styled('span')(({ theme }) => ({
  fontSize: theme.typography.pxToRem(14),
  color: 'rgba(0, 0, 0, 0.87)',
}));

export const ShowPDFButton = styled('span')(({ theme }) => ({
  fontSize: theme.typography.pxToRem(14),
  color: theme.palette.primary.main,
  cursor: 'pointer',
  textDecoration: 'underline',
}));
